import React, { useState } from 'react';
import * as R from 'ramda';
import { StyledTableWrapper, getUpdateDiv, tableRender } from './common';

export const columns = [
  {
    column: 'PASeq',
    label: '流水號',
    className: 'first',
  },
  {
    column: 'eventSeq',
    label: '事件順序',
  },
  {
    column: 'type',
    label: '事件種類',
  },
  {
    column: 'in_play',
    label: '球進場',
  },
  {
    column: 'is_strike',
    label: '是好球',
  },
  {
    column: 'is_ball',
    label: '是壞球',
  },
  {
    column: 'is_scoring',
    label: '有得分',
  },
  {
    column: 'first.name',
    label: '一壘',
  },
  {
    column: 'second.name',
    label: '二壘',
  },
  {
    column: 'third.name',
    label: '三壘',
  },
  {
    column: 'batter.name',
    label: '打者',
  },
  {
    column: 'pitcher.name',
    label: '投手',
  },
  {
    column: 'catcher.name',
    label: '捕手',
  },
  {
    column: 'strikes',
    label: '好球數',
  },
  {
    column: 'balls',
    label: '壞球數',
  },
  {
    column: 'pitch.code',
    label: '投球內容',
  },
  {
    column: 'pitch.velocity',
    label: '球速 KPH',
  },
  {
    column: 'pitch.RPM',
    label: '轉速 RPM',
  },
  {
    column: 'pitch.coord_x',
    label: '進壘點x',
  },
  {
    column: 'pitch.coord_y',
    label: '進壘點y',
  },
  {
    column: 'pitch.type',
    label: '球種',
  },
  {
    column: 'pitch.EV',
    label: '擊球初速 EV',
  },
  {
    column: 'pitch.trajectory',
    label: '擊球仰角',
  },
  {
    column: 'pitch.hardness',
    label: '擊球強勁',
  },
  {
    column: 'pitch.location_code',
    label: '擊球落點',
  },
  {
    column: 'pitch.location_coord_x',
    label: '擊球落點x',
  },
  {
    column: 'pitch.location_coord_y',
    label: '擊球落點y',
  },
  {
    column: 'pitch.fielder_position',
    label: '防守順序',
  },
  {
    column: 'video_signin_at',
    label: '捕手SignIn時間',
  },
  {
    column: 'video_started_at',
    label: '投球啟動時間',
  },
  {
    column: 'video_contact_at',
    label: '擊球瞬間',
  },
  {
    column: 'video_fly_catch_at',
    label: '飛球接/落時間',
  },
  {
    column: 'video_ground_catch_at',
    label: '滾地接捕時間',
  },
  {
    column: 'video_sb_throw_at',
    label: '盜壘捕手時間',
  },
  {
    column: 'video_sb_catch_at',
    label: '盜壘野手時間',
  },
];

export const toEventList = (PAList) => {
  return R.flatten(
    PAList.map((PA, PAIndex) => {
      let strikes = 0;
      let balls = 0;
      return PA.events.map((event, eventIndex) => {
        const data = {
          PASeq: PAIndex + 1,
          eventSeq: eventIndex + 1,
          strikes,
          balls,
          ...event,
        };
        if (event.is_strike && strikes < 2) {
          strikes++;
        }
        if (event.is_ball && balls < 3) {
          balls++;
        }
        return data;
      });
    }),
  );
};

const FormalGameEvents = ({ players, PAList, handleUpdate }) => {
  const [selectedRow, setSelectedRow] = useState(-1);
  const [selectColumn, setSelectColumn] = useState('');

  return (
    <div>
      {getUpdateDiv(
        toEventList(PAList),
        columns,
        setSelectedRow,
        setSelectColumn,
        selectedRow,
        selectColumn,
        handleUpdate,
      )}
      <StyledTableWrapper>
        {tableRender(toEventList(PAList), columns, setSelectedRow, setSelectColumn, selectedRow, selectColumn)}
      </StyledTableWrapper>
    </div>
  );
};

export default FormalGameEvents;
